/* Buy now.

   This does not add the item itself. It raises a flag and submits the product
   form, so the add runs through exactly the same handler as Add to cart and
   the only thing that differs is where the shopper lands afterwards.

   That matters more than it looks. A quantity of 3 on this store does not mean
   three of the same thing: the volume tiers put the page into pack mode, where
   the shopper chooses three different styles and the form posts one line per
   style. A Buy now that read the variant and the quantity off the page by
   itself would have quietly sent one style, three times, which is not what the
   page said they were buying.

   It adds to the bag rather than replacing it. Checking out this line alone
   would mean a shopper who has been building an order arrives at checkout to
   find the rest of it gone, and on this store it would drop them back under
   the free gift thresholds they were working towards. Every line is still
   visible and editable on the checkout page. */
(() => {
  const form = document.querySelector('[data-product-form]');
  const btn = document.querySelector('[data-buy-now]');
  if (!form || !btn) return;

  const label = btn.querySelector('[data-buy-now-label]');
  let busy = false;

  const release = (message) => {
    window.TFBuyNow = false;
    busy = false;
    btn.disabled = false;
    btn.classList.remove('is-busy');
    if (message) {
      label.textContent = message;
      setTimeout(() => { label.textContent = 'Buy now'; }, 2200);
    }
  };

  btn.addEventListener('click', () => {
    if (busy) return;

    // Add to cart already disables itself until the page is happy with the
    // selection: in pack mode that means every style in the pack has been
    // chosen. Defer to it rather than inventing a second rule, otherwise a
    // half-filled pack of three would check out as one.
    const atc = form.querySelector('[data-atc-button]');
    if (atc && atc.disabled) {
      const picker = document.querySelector('[data-vpick-summary], [data-vpick-open]');
      if (picker) picker.click();
      const asked = atc.querySelector('[data-atc-label]');
      return release(asked ? asked.textContent.trim() : 'Pick your styles');
    }

    busy = true;
    btn.disabled = true;
    btn.classList.add('is-busy');
    label.textContent = 'Taking you to checkout';
    window.TFBuyNow = true;

    if (form.requestSubmit) form.requestSubmit();
    else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));

    // The handler navigates on success. If we are still here well after that,
    // the add failed and cleared the flag, so hand the button back.
    setTimeout(() => { if (busy && !window.TFBuyNow) release('Try again'); }, 4000);
  });
})();
